"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const alarm_1 = require("../../../../@inax/alarm");
const translate_1 = require("../../../../@inax/translate");
const resource_service_1 = require("./../resources/resource.service");
let AlarmLineComponent = class AlarmLineComponent {
    constructor(_inaxAlarm, _inaxTranslate, _resourceManager) {
        this._inaxAlarm = _inaxAlarm;
        this._inaxTranslate = _inaxTranslate;
        this._resourceManager = _resourceManager;
        this._filter = "";
        this.alarms = [];
    }
    ngOnInit() {
        //subscribe to the services
        this._translateSubscription = this._inaxTranslate.ChangeEvent.subscribe(lng => this.updateAlarms());
        this._alarmSubscription = this._inaxAlarm.ChangeEvent.subscribe((alarmListEvent) => {
            this.updateAlarms();
        });
        this.updateAlarms();
    }
    ngOnDestroy() {
        //unsubscribe from the services
        if (this._alarmSubscription != null)
            this._alarmSubscription.unsubscribe();
        if (this._translateSubscription != null)
            this._translateSubscription.unsubscribe();
    }
    updateAlarms() {
        return __awaiter(this, void 0, void 0, function* () {
            this.alarms = yield this._inaxAlarm.alarmsAsync(this._filter, this._inaxTranslate.defaultLanguage, this._inaxTranslate.language, 0, 1);
        });
    }
};
AlarmLineComponent = __decorate([
    core_1.Component({
        selector: 'alarm-line',
        templateUrl: './@inax/alarmUi/src/alarmLine/alarm-line.component.html',
        styleUrls: ['./@inax/alarmUi/src/alarmLine/alarm-line.component.css']
    }),
    __metadata("design:paramtypes", [alarm_1.InaxAlarmService,
        translate_1.InaxTranslateService,
        resource_service_1.AlarmUiResourceManager])
], AlarmLineComponent);
exports.AlarmLineComponent = AlarmLineComponent;
